import { render, staticRenderFns } from "./Cgu.vue?vue&type=template&id=33b23472&scoped=true&"
import script from "./Cgu.vue?vue&type=script&lang=js&"
export * from "./Cgu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b23472",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-web/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33b23472')) {
      api.createRecord('33b23472', component.options)
    } else {
      api.reload('33b23472', component.options)
    }
    module.hot.accept("./Cgu.vue?vue&type=template&id=33b23472&scoped=true&", function () {
      api.rerender('33b23472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Cgu.vue"
export default component.exports